import * as fromDatatype from '../datatype-library/index';

export interface bl_rvm_cfp_engagement_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  value: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  engagement_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_rvm_cfp_engagement_line_RowClass
  implements bl_rvm_cfp_engagement_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  engagement_hdr_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  value: fromDatatype.NumericDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
  engagement_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
}
